import type { AbaDaFicha } from '../paginas/produtos/FichaProdutoVendo'

// A aba da ficha mora no endereco ("?aba=historico"), nao so na memoria da
// tela: ao voltar da tela do cliente (24/09 noite), a ficha tem de reabrir no
// Historico, e nao em Dados Comerciais. Valor estranho ou ausente = comercial.
export function abaDoEndereco(valor: string | null): AbaDaFicha {
  return valor === 'fiscal' || valor === 'historico' ? valor : 'comercial'
}
